import * as React from 'react';
import { Highchart, HighchartDataSeries, HighchartTitlesProps } from '../highchart/highchart';
import { getDataAttributes } from '../../util/attribute-util';

export interface ColumnChartDataPoint {
  label: string;
  value: number;
}

export interface ColumnChartProps extends HighchartTitlesProps {
  id: string;
  name: string;
  dataPoints: ColumnChartDataPoint[];
  onClick?: (name: string) => any;
  zoomType?: 'x' | 'xy' | 'y';
  useToolTip?: boolean;
}

/**
 * @deprecated use HighchartsStyled instead
 */

const componentName = 'ColumnChart';
export class ColumnChart extends React.Component<ColumnChartProps, {}> {
  private highchartRef: React.RefObject<Highchart> = React.createRef();

  get dataSeries(): HighchartDataSeries {
    return {
      id: this.props.id,
      name: this.props.name,
      type: 'column',
      data: this.props.dataPoints.map((p) => {
        return { name: p.label, y: p.value };
      }),
    };
  }

  render() {
    return (
      <div data-component={componentName} {...getDataAttributes(this.props)}>
        <Highchart
          type={'column'}
          ref={this.highchartRef}
          dataSeries={[this.dataSeries]}
          onClick={this.props.onClick}
          zoomType={this.props.zoomType}
          title={this.props.title}
          xAxisTitle={this.props.xAxisTitle}
          yAxisTitle={this.props.yAxisTitle}
          useToolTip={this.props.useToolTip}
        />
      </div>
    );
  }

  public reflow(): void {
    this.highchartRef.current.reflow();
  }
}

ColumnChart['displayName'] = componentName;
